var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.title,"name":"articles","url":_vm.$listRoutes.newArticles,"table":_vm.articles,"fields":_vm.fields,"filters":_vm.articlesFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }